import React, { useEffect, useRef } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import {
    AuthCallbackView,
    LoginView,
    LogoutView,
    SilentCallbackView,
} from '@klp/auth';

import { useAuth } from '@klpkonsern/auth-core';
import { AuthRoutes } from '@klpkonsern/auth-core/routes';
import { useCurrentUser } from '@klp/auth';

export const UnauthorisedRoutes: React.FC = () => {
    const { pathname, hash } = useLocation();

    const { currentUserIsLoading } = useCurrentUser();
    const { isAuthenticatedOidcUser, isAuthenticated } = useAuth();

    const hasUnmounted = useRef(false);

    useEffect(() => {
        return () => {
            hasUnmounted.current = true;
        };
    }, []);
    if (hasUnmounted.current) return null; // No render if component has unmounted
    if (currentUserIsLoading) return null; // Wait for user data to load, authorization is not determined yet
    if (isAuthenticatedOidcUser || isAuthenticated) return null; // User is already authenticated, no need to process anything here

    return (
        <Switch>
            <Route
                path={AuthRoutes.mainLogin}
                exact={true}
                render={() => {
                    <LoginView mainLogin={true} />;
                }}
            />
            <Route path={AuthRoutes.login} exact={true} component={LoginView} />
            <Route
                path={AuthRoutes.authCallback}
                exact={true}
                component={AuthCallbackView}
            />
            <Route
                path={AuthRoutes.authSilentCallback}
                exact={true}
                component={SilentCallbackView}
            />
            <Route
                path={AuthRoutes.logout}
                exact={true}
                component={LogoutView}
            />

            <Redirect
                to={{
                    pathname: AuthRoutes.login,
                    state: { referrer: `${pathname}${hash}` },
                }}
            />
        </Switch>
    );
};
